<template>
  <div class="user">
    <div class="title">
      <PlateTitle
        title="账户管理"
        class="plate"
      />
    </div>
    <a-spin :spinning="spinUser">
      <div class="manage">
        <div>
          <img src="../../assets/image/icon-IDcard.png">
          <span class="userTitle">企业名称</span>
          <span class="userMain">{{ this.$store.state.info.companyName }}</span>
          <a class="flex1" />
        </div>
        <div>
          <img src="../../assets/image/icon-sj.png">
          <span class="userTitle">手机号码</span>
          <span
            class="userMain"
            v-if="userMsg.phoneNum"
          >{{ telephone(userMsg.phoneNum) }}</span>
          <span
            class="userMain"
            v-else
          >手机号码未绑定</span>
          <PhoneNumber
            ref="phone"
            class="flex1"
          />
        </div>
        <div>
          <img src="../../assets/image/icon-dz.png">
          <span class="userTitle">联系地址</span>
          <span class="userMain">{{ userMsg.location }}</span>
          <Address class="flex1" />
        </div>
        <div>
          <img src="../../assets/image/icon-mm.png">
          <span class="userTitle">登录密码</span>
          <span class="userMain" />
          <Password
            class="flex1"
            :psw-type="userMsg.password"
          />
        </div>
      </div>
    </a-spin>
    <a-modal
      v-model="visible"
      :cancel-button-props="{ style: { display: 'none' } }"
      @ok="handleOk"
      centered
      :mask-closable="false"
      :keyboard="false"
      ok-text="确定"
    >
      <p>用户未登录，请重新登录。</p>
    </a-modal>
  </div>
</template>

<script>
import PlateTitle from '@/components/PlateTitle';
import PhoneNumber from './components/PhoneNumber';
import Address from './components/Address';
import Password from './components/Password';
import { info } from '@/api/user/user.js';
import { telephone } from '@/utils/format.js';
export default {
  name: 'User',
  components: { PlateTitle, PhoneNumber, Address, Password },
  data() {
    return {
      visible: false,
      userMsg: {},
      spinUser: false,
      telephone,
    };
  },
  mounted() {
    this.info();
  },
  methods: {
    handleOk() {
      this.$router.push({ name: 'login' });
    },
    info() {
      this.spinUser = true;
      info().then(res => {
        if (res.data.errorMsg === '用户未登录') {
          this.visible = true;
        } else {
          this.spinUser = false;
          this.userMsg = res.data.data;
          const _this = this.$refs.phone;
          _this.phone = res.data.data.phoneNum;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.user {
  height: 666px;
  .manage {
    div {
      height: 70px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #EBF2F7;
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .userTitle {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        width: 110px;
      }
      .userMain {
        width: 680px;
      }
      .flex1 {
        width: 70px;
        display: flex;
        flex-direction: row-reverse;
      }
    }
  }
}
</style>
